module.exports = __webpack_public_path__ + "static/estructura-1b26e76a82047d3e8efa58ef50d4e26a.jpg";